import ContactExtendedListViewCtrl from '../../../../store/contacts/controllers/extended-list-view';

angular
    .module('festzelt-os.contacts')
    .controller('ContactExtendedListViewCtrl', [
        'Contact',
        '$injector',
        '$scope',
        (Contact, $injector, $scope) => {
            return new ContactExtendedListViewCtrl(Contact, $injector, $scope)
        }
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/controllers/store/extended-listview.js